var _a;
import * as React from 'react';
import Cookies from 'universal-cookie';
export var Provider = (_a = React.createContext(new Cookies()), _a.Provider), Consumer = _a.Consumer;
